import { Typography, Paper } from '@mui/material'
import { useTranslation } from 'react-i18next'
import CheckDetailTitle from './CheckDetailTitle'
import TimelineDotLine from '../components/TimelineDotLine'
import CheckRiskStatus from '../components/CheckRiskStatus'

const CheckSintegra = ({ sintegraCheck }) => {
  const { t } = useTranslation(['common', 'messages'])
  const details = sintegraCheck?.checkDetails
  const hasChecks = sintegraCheck?.found !== false
  const checkLength = hasChecks ? 1 : 0

  // Adaptación para la estructura real
  const entry = details?.Entries?.[0]
  const addresses = entry?.Addresses || []
  const historicData = entry?.HistoricData || []
  const allStatesData = entry?.AllStatesData || []

  return (
    <>
      <Paper elevation={0} variant="colorPrimary" sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Typography>{t('common:sintegra')}</Typography>
        <CheckRiskStatus checkLength={checkLength} hasChecks={hasChecks} />
      </Paper>

      <CheckDetailTitle
        email={sintegraCheck?.email}
        status={sintegraCheck?.status}
        createdAt={sintegraCheck?.createdAt}
        updatedAt={sintegraCheck?.updatedAt}
      />

      {/* Caso sin datos o error explícito */}
      {(!hasChecks || !details?.Entries) && (
        <Paper variant="rootOutlined" elevation={0} sx={{ flex: 1, display: 'flex', alignItems: 'center', minHeight: 48 }}>
          <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
            {details?.StatusMessage && (
              <Typography variant="body2" color="text.secondary">
                {details.StatusMessage === 'NOT REGISTERED'
                  ? t('messages:notRegistered')
                  : t(`messages:${details.StatusMessage}`)}
              </Typography>
            )}
            {(details?.DetailedErrorMessage || (!details?.StatusMessage && !details?.DetailedErrorMessage)) && (
              <Typography variant="body2" color="error" sx={{ marginLeft: details?.StatusMessage ? 1 : 0 }}>
                {t('messages:noSintegraFound')}
              </Typography>
            )}
          </div>
        </Paper>
      )}

      {/* Caso con datos completos */}
      {hasChecks && entry && (
        <TimelineDotLine>
          <Paper variant="rootOutlined" elevation={0} sx={{ flex: 1 }}>
            <div className="c-detail-grid">
              <div className="c-detail-row">
                <Typography variant="subtitle1">{t('common:companyName')}</Typography>
                <Typography variant="subtitle3">{entry?.OfficialName || '---'}</Typography>
              </div>
              <div className="c-detail-row">
                <Typography variant="subtitle1">{t('common:creationDate')}</Typography>
                <Typography variant="subtitle3">{entry?.FoundingDate ? new Date(entry.FoundingDate).toLocaleDateString() : '---'}</Typography>
              </div>
              <div className="c-detail-row">
                <Typography variant="subtitle1">{t('common:stateRegistration')}</Typography>
                <Typography variant="subtitle3">{entry?.StateRegistration || '---'}</Typography>
              </div>
              <div className="c-detail-row">
                <Typography variant="subtitle1">{t('common:docNumberStatus')}</Typography>
                <Typography variant="subtitle3">{entry?.DocNumberStatus || '---'}</Typography>
              </div>
              <div className="c-detail-row">
                <Typography variant="subtitle1">{t('common:state')}</Typography>
                <Typography variant="subtitle3">{entry?.Status || '---'}</Typography>
              </div>
              <div className="c-detail-row">
                <Typography variant="subtitle1">{t('common:stateRegistrationType')}</Typography>
                <Typography variant="subtitle3">{entry?.StateRegistrationType || '---'}</Typography>
              </div>
              <div className="c-detail-row">
                <Typography variant="subtitle1">{t('common:mainCnae')}</Typography>
                <Typography variant="subtitle3">{entry?.MainCnae || '---'}</Typography>
              </div>
              <div className="c-detail-row">
                <Typography variant="subtitle1">{t('common:tributationRegime')}</Typography>
                <Typography variant="subtitle3">{entry?.TributationRegime || '---'}</Typography>
              </div>
              <div className="c-detail-row">
                <Typography variant="subtitle1">{t('common:informationAsRecipient')}</Typography>
                <Typography variant="subtitle3">{entry?.InformationAsRecipient || '---'}</Typography>
              </div>
              <div className="c-detail-row">
                <Typography variant="subtitle1">{t('common:companySize')}</Typography>
                <Typography variant="subtitle3">{entry?.CompanySize || '---'}</Typography>
              </div>
              <div className="c-detail-row">
                <Typography variant="subtitle1">{t('common:presumedCredit')}</Typography>
                <Typography variant="subtitle3">{entry?.PresumedCredit || '---'}</Typography>
              </div>
              <div className="c-detail-row">
                <Typography variant="subtitle1">{t('common:producerType')}</Typography>
                <Typography variant="subtitle3">{entry?.ProducerType ? t('common:yes') : t('common:no')}</Typography>
              </div>
            </div>

            {/* Direcciones */}
            {addresses.length > 0 && (
              <div style={{ marginTop: 16 }}>
                <Typography variant="subtitle2">{t('common:addresses')}</Typography>
                {addresses.map((addr, idx) => (
                  <div key={idx} className="c-detail-row">
                    <Typography variant="subtitle3">
                      {addr.AddressCore}, {addr.Number} - {addr.Neighborhood}, {addr.City}, {addr.State}, {addr.ZipCode}
                    </Typography>
                  </div>
                ))}
              </div>
            )}
            {historicData.length > 0 && (
              <div style={{ marginTop: 16 }}>
                <Typography variant="subtitle2">{t('common:historic')}</Typography>
                {historicData.map((hist, idx) => (
                  <div key={idx} className="c-detail-row">
                    <Typography variant="subtitle3">
                      {hist.StatusDate ? new Date(hist.StatusDate).toLocaleDateString() : '---'} - {hist.Reason} - {t(`common:${hist.StateRegistrationStatus}`)}
                    </Typography>
                  </div>
                ))}
              </div>
            )}
            {allStatesData.length > 0 && (
              <div style={{ marginTop: 16 }}>
                <Typography variant="subtitle2">{t('common:otherStatesRecords')}</Typography>
                {allStatesData.map((state, idx) => (
                  <div key={idx} className="c-detail-row">
                    <Typography variant="subtitle3">
                      {state.StateOfRegistration}: {state.StateRegistrationNumber} ({state.StateRegistrationStatus})
                    </Typography>
                  </div>
                ))}
              </div>
            )}
          </Paper>
        </TimelineDotLine>
      )}
    </>
  )
}

export default CheckSintegra
